module.exports = __webpack_public_path__ + "static/media/btnAdd.c327dcfe.svg";